// extracted by mini-css-extract-plugin
export default {"wrapper":"hG","subscription":"iG","select_item":"jG","is_selected":"kG","otb":"lG","radio":"mG","first_row":"nG","prices":"oG","italic":"pG","info_wrapper":"qG","first_month":"rG","separator":"sG","checkmark":"tG","bullets":"uG","bullet":"vG","checkmarkText":"wG","button":"xG","discountBadge":"yG"};
    if(module.hot) {
      // 1743628927217
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  